import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import * as moment from "moment";
import { Expense } from "../models/expense.model";
import { MomentFormatterService } from "src/app/shared/helpers/datetime/moment-formatter.service";

@Injectable({
    providedIn: "root"
  })

export class ExpensesService extends ApiBaseService {
    constructor(private configService: ConfigService, private http: HttpClient, private us: UserService, private momentFormatter: MomentFormatterService) {
      super(us);
      this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId, 'APIKEY': 'ams-direct-api-project-key', }) };
      this.baseUrl = `${this.configService.config.projectUrl}/api/expense`;
    }

    getNotConnectedToTimeWithinPeriod(fromDate: moment.Moment, toDate: moment.Moment): Observable<Expense[]> {
      const request = {
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Expense[]>(`${this.baseUrl}/getnotconnectedtotimewithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get expenses`)));
    }

    getByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Expense[]> {
      const request = {
         "ProjectId": id,
         "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
        };

      return this.http.post<Expense[]>(`${this.baseUrl}/getbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getApprovedByProjectWithinPeriod(id: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Expense[]> {
      const request = {
        "ProjectId": id,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Expense[]>(`${this.baseUrl}/getapprovedbyprojectwithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getByTimeEmployeeWithinPeriod(timeId: number, employeeId: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<Expense[]> {
      const request = {
        "TimeId": timeId,
        "EmployeeId": employeeId,
        "FromDate": this.momentFormatter.dateOnly(fromDate),
        "ToDate": this.momentFormatter.dateOnly(toDate)
      };

      return this.http.post<Expense[]>(`${this.baseUrl}/getbytimeandemployeewithinperiod`, request, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getByTime(id: number): Observable<Expense[]> {
      return this.http.get<Expense[]>(`${this.baseUrl}/getbytimeid?timeId=${id}`, this.httpOptions)
        .pipe(catchError(this.handleError<any>(`Failed to get additions`)));
    }

    getExpenseTypes() {
      return this.http.get<any>(this.baseUrl + "/GetExpenseTypes", this.httpOptions);
    }

    saveMultipleExpenses(expensesToAdd: any[], expensesToUpdate: any[]): Observable<any> {
      var expenses = {
        ExpensesToAdd: expensesToAdd,
        ExpensesToUpdate: expensesToUpdate
      };
      return this.http.post<any>(this.baseUrl + '/ExpenseSaveMultipleTimes', expenses, this.httpOptions);
    }

    deleteByExpenseIds(ids: number[]): Observable<any> {
      return this.http.post<any>(`${this.baseUrl}/DeleteExpenseByExpenseIds`, ids, this.httpOptions);
    }
}
